module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('router-link', {
    staticClass: "category-info",
    attrs: {
      "to": _vm.linkPath,
      "tag": "div"
    }
  }, [_c('div', {
    staticClass: "block",
    style: (_vm.blockColorString)
  }), _vm._v(" "), _c('br'), _vm._v("\n  " + _vm._s(_vm.category.name) + "\n")])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-339375d1!./~/vue-loader/lib/selector.js?type=template&index=0!./dev/src/components/CategoryInfoBlock.vue
// module id = ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-339375d1!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./dev/src/components/CategoryInfoBlock.vue
// module chunks = 0